<template>
	<div>
		<el-row :gutter="10">
			<el-col :xs="24" :sm="5">
				<div v-loading="loading" element-loading-text="获取数据中,请稍后" element-loading-spinner="el-icon-loading">
					<el-row :gutter="10">
						<el-col :xs="24" :sm="24">
							<el-card>
								<el-form size="mini" :model="searchData" ref="formSearch">
									<el-row :gutter="10">
										<el-col :sm="12" :xs="24">
											<el-form-item prop="area">
												<el-select v-model="searchData.area" placeholder="请选择省份">
													<el-option v-for="item in areaOptions" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
											<el-form-item prop="keywords">
												<el-input v-model="searchData.keywords" placeholder="医院名称" clearable
													maxlength="30">
												</el-input>
											</el-form-item>
										</el-col>
										<el-col :sm="12" :xs="24">
											<el-form-item prop="level">
												<el-select v-model="searchData.level" placeholder="请选择医院级别">
													<el-option v-for="item in levelOptions" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="未填市场数据" prop="if_no_dataset">
												<el-switch v-model="searchData.if_no_dataset">
												</el-switch>
											</el-form-item>
										</el-col>
									</el-row>
									<el-form-item>
										<el-button type="primary" plain @click="Search()">搜索</el-button>
										<el-button type="info" plain @click="resetSearch()">重置</el-button>
									</el-form-item>
								</el-form>
							</el-card>
						</el-col>
					</el-row>

					<el-card style="margin-top:10px;">
						<el-row>
							<el-table :data="tableData" style="width: 100%; " max-height="500" highlight-current-row>
								<el-table-column label="医院名称" prop="hospital_name" show-overflow-tooltip min-width="100"
									sortable>
									<template slot-scope="scope">
										<el-button v-if="scope.row.pk != $route.query.id" type="text"
											@click="jumpTo('/hospital_panel/', scope.row)">
											{{ scope.row.hospital_name }}
										</el-button>
										<div v-else class="active">{{ scope.row.hospital_name }}</div>
									</template>
								</el-table-column>
								<el-table-column label="地区" prop="hospital_city" sortable width="80"></el-table-column>
							</el-table>
						</el-row>

						<!-- 分页 -->
						<el-row class="paginator hidden-sm-and-down">
							<el-pagination background :current-page.sync="currentPage" layout="total, sizes, prev,next"
								:total="totalItems" :page-sizes="[20, 50, 100]" :page-size="pageSize"
								@current-change="handleCurrentChange" @size-change="handleSizeChange" />
						</el-row>

						<el-row class="paginator hidden-sm-and-up">
							<el-pagination background :current-page.sync="currentPage" layout="total, prev, next"
								:total="totalItems" :page-size="pageSize" @current-change="handleCurrentChange"
								@size-change="handleSizeChange" prev-text="上一页" next-text="下一页" />
						</el-row>
					</el-card>
				</div>
			</el-col>
			<el-col :xs="24" :sm="19">
				<el-alert title="请点击左侧医院列表查看详情" type="success" show-icon>
				</el-alert>
				<el-row>
					<el-col :xs="24" :sm="24">
						<el-card style="margin-bottom: 5px;">
							<el-descriptions size="medium" :title="hospital_info.hospital_name" :column="6" border>
								<el-descriptions-item label="省份">{{ hospital_info.hospital_area}}</el-descriptions-item>
								<el-descriptions-item label="市/地区">
									{{ hospital_info.hospital_city}}
								</el-descriptions-item>
								<el-descriptions-item
									label="等级">{{ hospital_info.hospital_level}}</el-descriptions-item>
								<el-descriptions-item label="类型">{{ hospital_info.hospital_type}}</el-descriptions-item>
								<el-descriptions-item label="床位数"><el-tag
										size="small">{{ hospital_info.hospital_bed_num}}</el-tag></el-descriptions-item>
								<el-descriptions-item label="备注">
									{{ hospital_info.hospital_remark}}
								</el-descriptions-item>
								<el-descriptions-item label="产品记录">
									{{ hospital_info.product_usage_record_num}}
								</el-descriptions-item>
								<el-descriptions-item label="设备记录">
									{{ hospital_info.equip_record_num}}
								</el-descriptions-item>
								<el-descriptions-item label="人员记录">
									{{ hospital_info.expert_record_num}}
								</el-descriptions-item>
								<el-descriptions-item label="供货记录">
									{{ hospital_info.supplyment_record_num}}
								</el-descriptions-item>
								<el-descriptions-item label="招标记录">
									{{ hospital_info.tender_record_num}}
								</el-descriptions-item>
								<el-descriptions-item label="服务记录">
									{{ hospital_info.visited_record_num}}
								</el-descriptions-item>
								<el-descriptions-item label="最后更新">
									{{hospital_info.update_date}}
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
					</el-col>
					<el-col :xs="24" :sm="24">
						<el-card>
							<el-tabs v-model="activeName" @tab-click="handleClick" tab-position="top">
								<el-tab-pane name="first">
									<span slot="label">
										<el-badge :value="hospital_info.product_usage_record_num" class="item">
										<i class="el-icon-s-goods"></i>
										产品使用情况
										</el-badge>
									</span>
									<div>
										<transition name="el-fade-in-linear"><router-view :key="$route.fullPath"
												name="a" v-if="isRouterAlive" /></transition>
									</div>
								</el-tab-pane>
								<el-tab-pane name="second">
									<span slot="label">
										<el-badge :value="hospital_info.equip_record_num" class="item">
										<i class="el-icon-s-tools"></i>
										科室设备及运转情况
										</el-badge>
									</span>
									<div>
										<transition name="el-fade-in-linear"><router-view :key="$route.fullPath"
												name="b" v-if="isRouterAlive" /></transition>
									</div>
								</el-tab-pane>
								<el-tab-pane name="third">
										<span slot="label">
											<el-badge :value="hospital_info.expert_record_num" class="item">
											<i class="el-icon-s-custom"></i>
											重要联系人
											</el-badge>
										</span>					
									<div>
										<transition name="el-fade-in-linear"><router-view :key="$route.fullPath"
												name="c" v-if="isRouterAlive" /></transition>
									</div>
								</el-tab-pane>
								<el-tab-pane name="fourth">
									<span slot="label">
										<el-badge :value="hospital_info.supplyment_record_num" class="item">
										<i class="el-icon-s-cooperation"></i>
										供货方式
										</el-badge>
									</span>
									<div>
										<transition name="el-fade-in-linear"><router-view :key="$route.fullPath"
												name="d" v-if="isRouterAlive" /></transition>
									</div>
								</el-tab-pane>
								<el-tab-pane name="fifth">
									<span slot="label">
										<el-badge :value="hospital_info.tender_record_num" class="item">
										<i class="el-icon-s-order"></i>
										招投标记录
										</el-badge>
									</span>
									<div>
										<transition name="el-fade-in-linear"><router-view :key="$route.fullPath"
												name="f" v-if="isRouterAlive" /></transition>
									</div>
								</el-tab-pane>
								<el-tab-pane name="sixth">
									<span slot="label">
										<el-badge :value="hospital_info.visited_record_num" class="item">
										<i class="el-icon-s-data"></i>
										市场服务记录
										</el-badge>
									</span>
									<div>
										<transition name="el-fade-in-linear"><router-view :key="$route.fullPath"
												name="e" v-if="isRouterAlive" /></transition>
									</div>
								</el-tab-pane>

							</el-tabs>
						</el-card>
					</el-col>
				</el-row>

			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		inject: ['reload', 'logout'],
		data() {
			return {
				tableData: [],
				ifFullScreen: false,
				totalItems: 100,
				currentPage: 1,
				pageSize: 20,
				loading: false,
				visible: false,
				activeName: 'first',
				isRouterAlive: true,
				searchData: {
					keywords: '',
					area: '',
					level: '',
					if_no_dataset: false,
				},
				hospital_info: {
					hospital_area: 'N/A',
					hospital_level: 'N/A',
					hospital_name: '医院名称',
					hospital_remark: 'N/A',
					hospital_type: 'N/A',
					hospital_bed_num: '0',
					equip_record_num: '0',
					expert_record_num: '0',
					supplyment_record_num: '0',
					product_usage_record_num: '0',
					visited_record_num: '0',
					tender_record_num:'0',
					update_date: ''
				},
				areaOptions: [{
						value: '北京',
						label: '北京'
					},
					{
						value: '天津',
						label: '天津'
					},
					{
						value: '上海',
						label: '上海'
					},
					{
						value: '重庆',
						label: '重庆'
					},
					{
						value: '河北',
						label: '河北'
					},
					{
						value: '山西',
						label: '山西'
					},
					{
						value: '辽宁',
						label: '辽宁'
					},
					{
						value: '吉林',
						label: '吉林'
					},
					{
						value: '黑龙江',
						label: '黑龙江'
					},
					{
						value: '江苏',
						label: '江苏'
					},
					{
						value: '浙江',
						label: '浙江'
					},
					{
						value: '安徽',
						label: '安徽'
					},
					{
						value: '福建',
						label: '福建'
					},
					{
						value: '江西',
						label: '江西'
					},
					{
						value: '山东',
						label: '山东'
					},
					{
						value: '河南',
						label: '河南'
					},
					{
						value: '湖北',
						label: '湖北'
					},
					{
						value: '湖南',
						label: '湖南'
					},
					{
						value: '广东',
						label: '广东'
					},
					{
						value: '甘肃',
						label: '甘肃'
					},
					{
						value: '四川',
						label: '四川'
					},
					{
						value: '贵州',
						label: '贵州'
					},
					{
						value: '海南',
						label: '海南'
					},
					{
						value: '云南',
						label: '云南'
					},
					{
						value: '青海',
						label: '青海'
					},
					{
						value: '陕西',
						label: '陕西'
					},
					{
						value: '广西',
						label: '广西'
					},
					{
						value: '西藏',
						label: '西藏'
					},
					{
						value: '宁夏',
						label: '宁夏'
					},
					{
						value: '新疆',
						label: '新疆'
					},
					{
						value: '内蒙',
						label: '内蒙'
					},
					{
						value: '澳门',
						label: '澳门'
					},
					{
						value: '香港',
						label: '香港'
					},
					{
						value: '台湾',
						label: '台湾'
					}
				],
				levelOptions: [{
						value: '三级特等',
						label: '三级特等'
					},
					{
						value: '三级甲等',
						label: '三级甲等'
					},
					{
						value: '三级乙等',
						label: '三级乙等'
					},
					{
						value: '三级丙等',
						label: '三级丙等'
					},
					{
						value: '二级甲等',
						label: '二级甲等'
					},
					{
						value: '二级乙等',
						label: '二级乙等'
					},
					{
						value: '二级丙等',
						label: '二级丙等'
					},
					{
						value: '一级甲等',
						label: '一级甲等'
					},
					{
						value: '一级乙等',
						label: '一级乙等'
					},
					{
						value: '一级丙等',
						label: '一级丙等'
					}
				],
			}
		},
		methods: {
			//通用函数-获取医院名单
			getData(queryData, currentPage, pageSize) {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				fd.append('currentpage', currentPage);
				fd.append('pagesize', pageSize);

				this.$axios({
						url: '/apim/get/hospital/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(response) {
						if (response.data.code == '401') {
							that.logout();
						} else {
							that.tableData = response.data.data;
							that.totalItems = response.data.totalItemNum;
							that.loading = false;
						}
					})
					.catch(function(error) {
						console.log(error);
						that.loading = false;
					});
			},
			//通用功能 - 关键字搜索
			Search() {
				let that = this;
				this.currentPage = 1;
				this.getData(that.searchData, that.currentPage, that.pageSize);
			},
			resetSearch() {
				this.$router.push({
					path: '/hospital_panel/'
				})
				let that = this;
				this.currentPage = 1;
				this.$refs['formSearch'].resetFields();
				this.getData(that.searchData, that.currentPage, that.pageSize);
				this.hospital_info = {
					hospital_area: '待获取',
					hospital_city: '待获取',
					hospital_level: '待获取',
					hospital_name: '医院名称',
					hospital_remark: '待获取',
					hospital_type: '待获取',
					hospital_bed_num: '待获取',
					equip_record_num: '待获取',
					expert_record_num: '待获取',
					supplyment_record_num: '待获取',
					product_usage_record_num: '待获取',
					visited_record_num: '待获取',
					tender_record_num: '待获取',
					update_date: '待获取'
				};
			},
			//分页跳转
			handleCurrentChange(val) {
				let that = this;
				this.currentPage = val;
				this.getData(that.searchData, that.currentPage, that.pageSize);
			},
			//每页显示条数更改
			handleSizeChange(val) {
				let that = this;
				this.pageSize = val;
				this.currentPage = 1;
				this.getData(that.searchData, that.currentPage, that.pageSize);
			},
			//路由跳转
			jumpTo(name, row) {
				// let that=this;
				// this.getData(that.searchData, that.currentPage, that.pageSize);
				this.$router.push({
					path: name,
					query: {
						id: row.pk
					}
				})
				if (this.$route.params.id != '0') {
					this.hospital_info = row;
				}

			},
			handleClick(tab, event) {
				// console.log(tab, event);
			},
		},
		mounted() {
			let that = this;
			this.getData(that.searchData, that.currentPage, that.pageSize);
			this.hospital_info = {
				hospital_area: '待获取',
				hospital_city: '待获取',
				hospital_level: '待获取',
				hospital_name: '医院名称',
				hospital_remark: '待获取',
				hospital_type: '待获取',
				hospital_bed_num: '待获取'
			};
		}
	};
</script>

<style>
	.item {
	  margin-top: 12px;
	  margin-right: 5px;
	}
	
</style>